// Medidas compartilhadas do shell mobile (MobileLayout) usadas por quem precisa
// ficar "colado" abaixo do AppBar azul (ex.: topo fixo das listagens).
export const APP_BAR_HEIGHT = 61;

// Altura total do AppBar sticky (inclui a safe-area do topo).
export const APP_BAR_OFFSET = `calc(${APP_BAR_HEIGHT}px + env(safe-area-inset-top, 0px))`;
